import '@dotlottie/player-component';
import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild} from '@angular/core';
import {DotLottiePlayer} from "@dotlottie/player-component";
import {DotLottie, DotLottieWorker} from "@lottiefiles/dotlottie-web";

//TODO remove @dotlottie/player-component from package.json and here
@Component({
  selector: 'brt-dot-lottie',
  templateUrl: './dot-lottie.component.html',
  styleUrls: ['./dot-lottie.component.scss']
})
export class DotLottieComponent implements AfterViewInit, OnDestroy {
  @ViewChild("mainEl") mainEl!: ElementRef;
  @Input('path') path!: string;
  @Output('instanceCreated') instanceCreated = new EventEmitter<DotLottie>();
  @Input('autoplay') autoplay = true;
  @Input('loop') loop = true;

  lottieInstance?: DotLottie;

  async ngAfterViewInit() {
    const mainEl = this.mainEl.nativeElement as HTMLElement;

    this.lottieInstance = new DotLottie({
      autoplay: this.autoplay,
      loop: this.loop,
      canvas: mainEl.querySelector('canvas') as HTMLCanvasElement,
      src: this.path, // or .json file
      useFrameInterpolation: false,
      renderConfig: {
        devicePixelRatio: 1
      }
    });

    this.lottieInstance.addEventListener('loadError', console.error);

    // console.log(this.lottieInstance);

    // console.log(this.lottieInstance.isLoaded);
    // console.log(this.lottieInstance.isReady);
    //
    // console.log(this.lottieInstance.canvas);

    if(this.lottieInstance.isLoaded) {
      this.lottieInstance.play();
    } else {
      this.lottieInstance.addEventListener("load", () => {
        if(this.lottieInstance) {
          // console.log("Dotlottie load event");
          this.lottieInstance.play();

          this.instanceCreated.emit(this.lottieInstance);
        }

      })

      // this.lottieInstance.addEventListener("ready", () => {
      //   if(this.lottieInstance) {
      //     console.log("Dotlottie Ready event");
      //     this.lottieInstance.play();
      //   }
      //
      // })

      this.lottieInstance.addEventListener("loadError", (event) => {
        // console.log(event);
      })
    }


    // const lottie = mainEl.querySelector("dotlottie-player") as DotLottiePlayer;
    // lottie.autoplay = true;
    // lottie.loop = "true";
    // lottie.src = this.path;
    //
    // lottie.addEventListener("ready", () => {
    //   if(lottie.src) {
    //     lottie.load(lottie.src).then(() => {
    //       lottie.play();
    //     });
    //   }
    // }, {once: true}); // important once true
    //
    // lottie.addEventListener("destroy", (e) => {
    //   alert("ASD")
    // })
  }

  ngOnDestroy() {

    if(this.lottieInstance) {
      this.lottieInstance.destroy();
    }
  }
}
